import { call, put, select, takeEvery } from 'redux-saga/effects';
import { fetchListDataFailure, fetchListDataStart, fetchListDataSuccess, loadListDataRequest } from '../listSlice';
import { getListApi } from '../../api/apiLists/getListApi';
import buildFilters from '../../utils/filterLogic';
import { callWithAuth } from '../sagaApiHelper';
import { hideLoader, showLoader } from '../loaderSlice';

function getStableFilterHash(filterConditions) {
    const sorted = Object.keys(filterConditions)
        .sort()
        .reduce((acc, key) => {
            acc[key] = filterConditions[key];
            return acc;
        }, {});
    return JSON.stringify(sorted);
}

function* handleFetchList(action) {
    const { key, filterConditions, offset } = action.payload;
    const filterHash = getStableFilterHash(filterConditions);

    // Check cache
    const cachedData = yield select((state) => {
        const listEntry = state.list[key];
        if (listEntry && listEntry.cache && listEntry.cache[filterHash]) {
            return listEntry.cache[filterHash][offset];
        }
        return null;
    });

    if (cachedData) {
        yield put(fetchListDataSuccess({
            key,
            rows: cachedData.rows,
            totalCount: cachedData.totalCount,
            pageSize: cachedData.pageSize,
            offset,
            filterHash,
        }));
        return;
    }

    try {
        yield put(showLoader());
        const { filters } = buildFilters(key, filterConditions);
        yield put(fetchListDataStart(key));
        const res = yield call(callWithAuth, getListApi, [key, filters, offset]);
        const { rows, totalCount, pageSize } = res.data;

        yield put(fetchListDataSuccess({
            key,
            rows,
            totalCount,
            pageSize,
            offset,
            filterHash,
        }));
        yield put(hideLoader());
    } catch (error) {
        yield put(fetchListDataFailure({ key, error: error.message }));
        yield put(hideLoader());
    }
}

export default function* listSaga() {
    yield takeEvery(loadListDataRequest.type, handleFetchList);
}
